module.exports = __webpack_public_path__ + "static/3dgensfront-917b53e6c5bf3ab25989534d50c0d5cc.png";